// extracted by mini-css-extract-plugin
export default {"container":"ellipsis_container__ciMmU","line_clamp":"ellipsis_line_clamp__-H088"};